import { del, get } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getApplicationList = async (page, pageSize = 10) => {
  const builder = new UrlBuilder(`/documents/get-lists`);
  builder.add('page', page);
  builder.add('pageSize', pageSize);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const deleteApplication = async (payload) => {
  const builder = new UrlBuilder(`/documents/delete-list`);

  try {
    const response = await del(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
